import {
  Center,
} from '@chakra-ui/react';
import { parse } from 'mini-querystring';
import React from 'react';
import { useQuerystringParam } from 'shared/src/hooks/useQuerystringParam';
import useRequest from 'shared/src/hooks/useRequest';
import BigModal from '../../BigModal/BigModal';
import WaitFor from '../../data/WaitFor';

const getRedirectPath = () => parse(window.document.location.search).redirect_to || '/';

const WorkOSSignIn = ({ client }) => {
  const [email] = useQuerystringParam('email', null, { squash: true });

  const urlRequest = useRequest(
    async () => {
      const clientId = process.env.REACT_APP_WORKOS_CLIENT_ID;

      const authUrl = new URL('https://api.workos.com/sso/authorize');
      authUrl.searchParams.set('client_id', clientId);
      authUrl.searchParams.set('provider', 'authkit');
      authUrl.searchParams.set('redirect_uri', `${window.location.protocol}//${window.location.host}`);
      authUrl.searchParams.set('response_type', 'code');
      authUrl.searchParams.set('state', JSON.stringify({ redirect_to: getRedirectPath() }));
      authUrl.searchParams.set('screen_hint', 'sign-in');
      if (email) {
        // Used by our invite emails
        authUrl.searchParams.set('login_hint', email);
      }

      window.location = authUrl.href;
    },
    [],
  );

  return (
    <BigModal open>
      <BigModal.Contents>
        <BigModal.Body>
          <Center w="100%" h="100%">
            <WaitFor />
          </Center>
        </BigModal.Body>
      </BigModal.Contents>
    </BigModal>
  );
};

export default WorkOSSignIn;
